export const languageStringsCampaign = {
  leavingWithChanges:
    "You have unsaved changes in the campaign. Do you want to discard them?",
  addFirstCampaign: "Add your first campaign",
  setUpFirstCampaign: "Set up your first campaign and start earning.",
  addCampaign: "Add campaign",
  addNotification: "Add notification",
  deleteCampaign: "Delete campaign?",
  preview: "Preview",
  unnamedCampaign: "(unnamed)",
  table: {
    name: "Name",
    creationDate: "Created",
    notificationCount: "Notifications",
    status: "Status",
    delete: "Delete",
  },
  settings: {
    all: "SHOW EVERYWHERE",
    custom: "CUSTOM SELECTION",
    title: "Display",
    campaignName: "Campaign name",
    setCampaign: "Campaign settings",
    newCampaign: "New campaign",
    whereWillCampaignBeShown: "Where will the campaign be shown",
    allDescription:
      "Notifications will be displayed across your entire website. If you want to exclude certain pages or define specific pages where this campaign's notifications should appear, switch to 'Custom Selection'.",
    url: {
      title: "Website link (URL)",
      startsWith: "Starts with",
      includes: "Includes",
      equals: "Equals",
    },
    includes: "Includes",
    exclude: "Excludes (optional)",
    addCondition: "Add condition",
  },
  design: {
    title: "Device",
    notificationsDesign: "Notification appearance",
    designDescription:
      "These are settings for the entire campaign. You can customize the appearance for individual notifications in their own settings.",
    computerOff: "Notifications will not be shown on desktop devices (PC)",
    mobileOff: "Notifications will not be shown on mobile devices",
    computer: "Show on Desktop",
    mobile: "Show on Mobile",
    position: "Position",
    downLeftCorner: "Bottom left corner",
    downRightCorner: "Bottom right corner",
    upLeftCorner: "Top left corner",
    upRightCorner: "Top right corner",
    down: "Bottom",
    up: "Top",
    animations: "Animations",
    playAnimation: "Play animation",
    animationSettings: {
      showAfter: "Notification will appear after",
      showDelay: "Display duration",
      delayBetween: "Delay between notifications",
      showSpeed: "Display speed",
      second: "second",
      seconds: "seconds",
    },
  },
  notifications: {
    title: "Notifications",
    noNotifications: "You don't have any notifications yet",
    addNewNotification: "Add notification",
    addNotificationHelperText:
      "Select and click on at least one of the 8 displayed boxes (notification types)",
    table: {
      type: "Type",
      preview: "Preview",
      status: "Off / On",
    },
    settings: {
      customization: {
        title: "Settings",
      },
      displayRules: {
        title: "Display rules",
        text: "Text",
        notificationText: "Notification text",
        variant: "Variant",
        choseVariant: "Select a variant",
        days: "days",
        h: "h",
        addKey: "Insert API Key",
        show: "Show",
        notificationName: "Notification name",
        nameNotification: "Name the notification",
        repeatNotification: "Repeat notifications",
        fillNotificationText: "Enter the notification Text",
        actualVisitors: {
          nameVisitors: "Name the visitors",
          visitors: "visitors",
          maxVisitors: "Minimum number of visitors to display",
        },
        lastOrders: {
          maxLast: "Maximum recent",
          maxToShow: "Minimum number to display",
          whenAtLeast: "Notification only if at least",
          ordersLast: "Orders in the last",
          haveOrderedPlaceholder: "has already ordered. What about you?",
          showOwnOrders: "Show visitors their own orders",
          notRecoginzed: 'Unrecognized names like "Customer"',
          orders: "orders",
        },
        lastRegistrations: {
          maxLast: "Maximum recent",
          registrations: "registrations",
          notRecoginzed: 'Unrecognized names like "Visitor"',
          registrationsLast: "Registrations in the last",
          showOwnRegistrations: "Show visitors their own registrations",
          isRegistredPlaceholder: "has completed registration",
        },
        visitorSummary: {
          visitors: "Visitors",
          registrations: "Registrations",
          orders: "Orders",
          visitors2: "visitors",
          registrations2: "registrations",
          orders2: "orders",
          last: "in the last",
          minNumber: "Minimum number",
          toShow: "to display",
        },
        individual: {
          link: "Link",
          button: "Button",
          buttonName: "Name the button",
          url: "Target website URL",
          buttonAsLink: "Link as button",
          textColor: "Text color",
          openLinkInNewWindow: "Open link in new window",
          buttonColor: "Button color",
          removedLinkDescription: "Removing the link allows for longer text.",
          tooLongTextErrorMessage: "Text exceeds maximum length.",
          tooltip:
            "Enter the full URL including http:// or https://. For example, if you enter https://www.seznam.cz, users will be redirected there when clicking the button.",
        },
        webName: "Website name",
        apiKey: "API Key",
        heureka: {
          title: "Integration with Heureka",
          description:
            "To activate this notification, a Heureka API key is required. Would you like to add it?",
          heurekaApiKey: "Heureka API Key",
          country: "Country",
          stars: "stars",
          reviewsWithRating: "Reviews with rating over",
          maxReviews: "Minimum number of reviews to display",
          howToAddApiKey: {
            title: "How to add Heureka key",
            first:
              "In your Heureka account, select E-shop Administration from the top menu.",
            second: "In the left menu, select Verified by Customers.",
            third: "Copy the secret key and paste it into the API key field.",
            thirdHelp:
              "The key is available if you have enough reviews and meet the Verified by Customers conditions.",
            fourth: "Verify the status",
          },
        },
        zbozi: {
          title: "Integration with Zboží.cz",
          description:
            "To activate this notification, a Zboží.cz API key is required. Would you like to add it?",
          howToAddKey: "How to add Zboží.cz API Key",
          shopId: "Shop ID",
          storeReview: "Store rating",
          productReview: "Product rating",
          maxReviews: "Minimum number of reviews to display",
          howToAddApiKey: {
            title: "How to add a Sklik API key",
            first:
              "Log in to your Sklik account at sklik.cz and select Settings from the top menu.",
            second:
              "In the left menu, find API keys and click Add key.",
            third:
              "Enter a key name, copy the generated refresh token, and paste it into the API key field above. Enter your Shop ID (ID provozovny) from Zboží.cz into the Shop ID field.",
            thirdHelp:
              "The Zboží.cz API has been replaced by the new Sklik API. Your Shop ID (ID provozovny) remains the same – you can find it in your Zboží.cz account under Provozovna.",
            fourth: "Verify the connection using the Check button.",
          },
        },
        spolehlivaRecenze: {
          title: "Integration with Spolehlivé Recenze",
          description:
            "To activate this notification, you must log in to Spolehlivé Recenze. Would you like to log in?",
          howToAddApiKey: {
            title: "How to log in to Spolehlivé Recenze",
            first:
              "Copy your shop ID and password from your Spolehlivé Recenze account.",
            second: "Enter these details into the appropriate fields above.",
            third: "Verify the status.",
          },
        },
        googleReviews: {
          title: "Connection with Google Reviews",
          apiKey: "API Key",
          searchPlace: "Search for your business on Google Maps",
          placeId: "Place ID",
          companyName: "Company name",
          description:
            "To activate this notification, you must fill in the Place ID, which you can find using the search field for businesses in Google Maps.",
          howToAddApiKey: {
            title: "How to add Google Reviews",
            first:
              "In the Search for your business field, we recommend entering the identical name as you have in Google Maps.",
            second:
              "In the search window, select your business that will serve as the source of reviews. The Place ID field will be automatically pre-filled",
            third: "Verify the status.",
          },
          maxReviews: "Minimum number of reviews to display",
          reviewsWithRating: "Reviews with more than",
          stars: "stars",
          noOptions: "No options",
        },
        trustPilot: {
          title: "Integration with TrustPilot",
          description:
            "To activate this notification, a TrustPilot API key and Business Unit ID are required. Would you like to add an API key?",
          howToAddApiKey: {
            title: "How to add TrustPilot identifier",
            first: "Visit your TrustPilot business page",
            second:
              "Copy the name from URL. From address https://trustpilot.com/review/my-company copy only the part my-company",
            third: "Enter this name in the field above",
          },
          minReviews: "Minimum number of reviews to display",
          reviewsWithRating: "Reviews with more than",
          stars: "stars",
        },
      },
      pairing: {
        title: "Pairing",
        collectData: "Data capture",
        addCondition: "Add condition",
        cantEdit: "Cannot be edited",
        pairingCondition: "Pairing rule",
        selectedDomain: "Selected domain",
        pageVisitors: "Visitors of individual pages",
        domainVisitors: "Summaries of visitors for the entire domain",
        campaignCollects:
          "The campaign will track visitors of each page individually.",
      },
      design: {
        title: "Design",
        description:
          "The default design is set for the entire campaign. You can adjust it here for a specific notification.",
        backgroundColor: "Background color",
        textColor: "Text color",
        iconbackgroundColor: "Icon background color",
        iconColor: "Icon color",
        roundedCorners: "Rounded corners",
        icon: "Icon",
      },
    },
    deleteModal: {
      title: "Delete notifications?",
      description: "All data will be deleted.",
    },
    lastOrders: {
      title: "Recent orders",
      description: "Recommended for e-shops with 10 or more orders per week.",
      previewText1: "Josef from Košice",
      previewText2: "has completed an order",
    },
    lastRegistrations: {
      title: "Recent registrations",
      description:
        "Recommended for lead generation websites and contact collection sites.",
      previewText1: "Josef from Košice",
      previewText2: "has completed registration",
    },
    actualVisitors: {
      title: "Traffic – current statistics",
      description:
        "Recommended for websites with a minimum daily traffic of 1,000.",
      previewText1: "visitors",
    },
    visitorSummary: {
      title: "Traffic – summary statistics",
      description: "Recommended for websites with daily traffic under 1,000.",
      previewText1: "visitors",
      previewText2: "users",
    },
    registrationSummary: {
      title: "Registrations – summary statistics",
    },
    orderSummary: {
      title: "Traffic – summary statistics",
    },
    heureka: {
      title: "Heureka – reviews and ratings",
      description:
        "Recommended for e-shops with positive text reviews on Heureka.",
      previewText1:
        "Compared to the 12 Pro Max, I appreciate the amazing camera (4K videos are top) and also the photos – a huge improvement. Excellent macro. Fast and reliable phone. Very satisfied. The color is beautiful.",
      previewText2: "recommends",
    },
    zbozi: {
      title: "Zboží.cz – reviews and ratings",
      description:
        "Recommended for e-shops with positive text reviews on Zboží.cz.",
      previewText1:
        "Compared to the 12 Pro Max, I appreciate the amazing camera (4K videos are top) and also the photos – a huge improvement. Excellent macro. Fast and reliable phone. Very satisfied. The color is beautiful.",
      previewText2: "recommends",
    },
    individual: {
      title: "Custom",
      description:
        "Customize the notification text however you like. Great for promoting discounts, free shipping, or other benefits of your products and services.",
      previewText1:
        "Register on our e-shop and get a 5% discount on your purchase.",
      previewText2: "Get a gift",
    },
    shoptetLastOrders: {
      title: "Recent orders for Shoptet",
      description:
        "Exclusive notification for e-shops on the Shoptet platform.",
      timeRange: "Time range",
      showRandom: "Display random orders from the last",
      twoMonths: "2 months",
      screwdriver: "Screwdriver",
    },
    shoptetCouponCode: {
      title: "Shoptet discount code",
      description:
        "Exclusive notification for e-shops on the Shoptet platform.",
      info: "This notification assumes you have created a discount coupon on the Shoptet platform and will provide its details here.",
      code: "Discount code",
      saleType: "Discount value",
      saleIn: "Discount in",
      saleOn: "Discount on",
      wholeSale: "Entire purchase",
      sale10: "DISCOUNT10",
      previewText:
        'Use the discount code "DISCOUNT10" to get 10% off your entire purchase.',
    },
    eshopRychleLastOrders: {
      title: "Last orders for Eshop-rychle",
      description: "Exclusive notification for e-shops on the Eshop-rychle platform.",
      timeRange: "Time range",
      showRandom: "Display random orders from the last",
      twoMonths: "2 months",
      screwdriver: "Screwdriver",
    },
    shopifyLastOrders: {
      title: "Last orders for Shopify",
      description: "Exclusive notification for e-shops on the Shopify platform.",
      timeRange: "Time range",
      showRandom: "Display random orders from the last",
      twoMonths: "2 months",
      screwdriver: "iPhone 15 Pro",
    },
    spolehlivaRecenzeShopRating: {
      title: "Spolehlivé Recenze – reviews and ratings",
      description:
        "Recommended for e-shops with positive text reviews on spolehliverecenze.cz.",
      previewText1:
        "Shopping on this e-shop was amazing. The order arrived quickly, and the product exceeded my expectations. Great customer service, I'll definitely shop here again!",
    },
    spolehlivaRecenzeProductRating: {
      title: "Spolehlivé Recenze – reviews and ratings",
      description:
        "Recommended for e-shops with positive text reviews on spolehliverecenze.cz.",
      previewText1:
        "This product is absolutely fantastic! The build quality is top-notch, it works exactly as described, and the price/performance ratio is excellent. I highly recommend it.",
    },
    googleReviews: {
      title: "Google Reviews – ratings and feedback",
      description:
        "Recommended for e-shops with positive text reviews on Google.",
      previewText1:
        "Compared to the 12 Pro Max, I appreciate the amazing camera (4K videos are top) and the photos – a big improvement. Excellent macro. Fast and reliable phone. Very satisfied. The color is beautiful.",
      previewText2: "recommends",
    },
    trustPilot: {
      title: "TrustPilot – reviews and ratings",
      description:
        "Recommended for e-shops with positive text reviews on TrustPilot.",
      previewText1:
        "Great store with excellent customer service. The goods arrived quickly and in good condition. Communication was hassle-free and quick. I can only recommend it, I will definitely buy again.",
      previewText2: "recommends",
    },
  },
  branding: {
    title: "Branding",
    sizeAndForm: {
      title: "Notification size and shape",
      classic: "Classic",
      small: "Small",
      compact: "Compact",
    },
    defaultSettings: {
      title: "Default settings",
      backgroundColor: "Background color",
      textColor: "Text color",
      backgroundOpacity: "Background opacity",
      borderRadius: "Border radius",
    },
    icons: {
      title: "Show icons",
      iconColor: "Icon color",
      backgroundColor: "Icon background color",
      backgroundRadius: "Icon background radius",
    },
  },
  analytics: {
    title: "Data Analytics",
    lastOrders: "Recent Orders",
    lastRegistrations: "Recent Registrations",
    updateData: "Update Data",
    dateAndTime: "Date and Time",
    customerName: "Customer Name",
    customerLocation: "Customer Location",
  },
  standardSettingsModal: {
    title: "Appearance will be reset to default settings",
    description: "All your changes will be overwritten.",
    applyButton: "Apply default settings",
    closeButton: "Close",
  },
};
